<template>
   <div class="app-container">
      <el-row :gutter="20">
         <!--部门数据-->
         <!-- <el-col :span="4" :xs="24">
            <div class="head-container">
               <el-input
                  v-model="deptName"
                  :placeholder="$t('global.plsInput') + '会社名'"
                  clearable
                  prefix-icon="Search"
                  style="margin-bottom: 20px"
               />
            </div>
            <div class="head-container">
               <el-tree
                  style="width: ;"
                  :data="deptOptions"
                  :props="{ label: 'label', children: 'children' }"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  ref="deptTreeRef"
                  node-key="id"
                  highlight-current
                  default-expand-all
               >
                  <template #default="{ node, data}">
                     <el-tooltip :content="node.label" placement="top" v-if="checkTextOverflow(node.label)">
                        <span class="overflow-text" @click="handleNodeClick(data)">{{ truncateText(node.label, 10) }}</span>
                     </el-tooltip>
                     <span @click="handleNodeClick(data)" v-else>{{ node.label }}</span>
                  </template>
               </el-tree>
            </div>
         </el-col> -->
         <!--用户数据-->
         <el-col :span="24" :xs="24">
            <el-form :model="queryParams" ref="queryRef" :inline="true" v-show="showSearch" label-width="108px">
               <el-form-item :label="$t('user.name')" prop="userName">
                  <el-input
                     v-model="queryParams.userName"
                     :placeholder="$t('user.name') + $t('global.plsInput')"
                     clearable
                     style="width: 240px"
                     v-ctrl-enter="handleQuery"
                  />
               </el-form-item>
               <el-form-item :label="$t('user.phone')" prop="phonenumber">
                  <el-input
                     v-model="queryParams.phonenumber"
                     :placeholder="$t('user.phone') + $t('global.plsInput')"
                     clearable
                     style="width: 240px"
                     v-ctrl-enter="handleQuery"
                  />
               </el-form-item>
               <el-form-item :label="$t('global.status')" prop="status">
                  <keep-result-select
                     style="width: 240px"
                     :placeholder="$t('global.status') + $t('global.plsSelect')"
                     v-model="queryParams.status"
                     :list="sys_normal_disable"
                  />
               </el-form-item>
               <el-form-item :label="$t('movie.companyIds')" prop="deptId">
                  <LazyLoadSelect
                     v-model:modelValue="queryParams.deptId"
                     :list="deptList"
                     :placeholder="$t('movie.companyIds') + $t('global.plsSelect')"
                     searchKey="deptName"
                     labelKey="deptName"
                     valueKey="deptId"
                     :fetchOptions="listDept"
                  />
                  <!-- <el-select
                     remote
                     :remote-method="debounceSearch"
                     v-load-more="loadMoreFn"
                     ref="selectRef"
                     v-model="queryParams.companyIds"
                     :placeholder="$t('movie.companyIds') + $t('global.plsSelect')"
                     clearable
                     filterable
                     style="width: 240px"
                  >
                     <el-option
                        v-for="(item, idx) in deptList"
                        :key="idx"
                        :label="item.deptName"
                        :value="item.deptId"
                     ></el-option>
                  </el-select> -->
               </el-form-item>
               <el-form-item :label="$t('global.createTime')" style="width: 308px;">
                  <el-date-picker
                     v-model="dateRange"
                     value-format="YYYY-MM-DD"
                     type="daterange"
                     range-separator="-"
                     :start-placeholder="$t('global.startDate')"
                     :end-placeholder="$t('global.endDate')"
                  ></el-date-picker>
               </el-form-item>
               <el-form-item>
                  <el-button type="primary" icon="Search" @click="handleQuery">{{ $t('global.search') }}</el-button>
                  <el-button icon="Refresh" @click="resetQuery">{{ $t('global.reset') }}</el-button>
               </el-form-item>
            </el-form>

            <el-row :gutter="10" class="mb8">
               <el-col :span="1.5">
                  <el-button
                     type="primary"
                     plain
                     icon="Plus"
                     @click="handleAdd"
                     v-hasPermi="['system:user:add']"
                  >{{ $t('global.add') }}</el-button>
               </el-col>
               <!-- <el-col :span="1.5">
                  <el-button
                     type="success"
                     plain
                     icon="Edit"
                     :disabled="single"
                     @click="handleUpdate"
                     v-hasPermi="['system:user:edit']"
                  >{{ $t('global.edit') }}</el-button>
               </el-col> -->
               <el-col :span="1.5">
                  <el-button
                     type="danger"
                     plain
                     icon="Delete"
                     :disabled="multiple"
                     @click="handleDelete"
                     v-hasPermi="['system:user:remove']"
                  >{{ $t('global.delete') }}</el-button>
               </el-col>
               <el-col :span="1.5">
                  <el-button
                     type="info"
                     plain
                     icon="Upload"
                     @click="handleImport"
                     v-hasPermi="['system:user:import']"
                  >{{ $t('global.import') }}</el-button>
               </el-col>
               <el-col :span="1.5">
                  <el-button
                     type="warning"
                     plain
                     icon="Download"
                     @click="handleExport"
                     v-hasPermi="['system:user:export']"
                  >{{ $t('global.export') }}</el-button>
               </el-col>
               <!-- <right-toolbar v-model:showSearch="showSearch" @queryTable="getList" :columns="columns"></right-toolbar> -->
            </el-row>

            <el-table ref="multipleTable" v-loading="loading" :data="userList" @selection-change="handleSelectionChange">
               <el-table-column type="selection" width="50" align="center" :selectable="selectable" />
               <el-table-column :label="$t('user.userId')" align="center" key="userId" prop="userId" v-if="columns.length > 0 && columns[0].visible" />
               <el-table-column :label="$t('user.name')" align="center" key="userName" prop="userName" v-if="columns.length > 0 && columns[1].visible" :show-overflow-tooltip="true" />
               <el-table-column :label="$t('user.abbr')" align="center" key="nickName" prop="nickName" v-if="columns.length > 0 && columns[2].visible" :show-overflow-tooltip="true" />
               <el-table-column :label="$t('user.dept')" align="center" key="deptName" v-if="columns.length > 0 && columns[3].visible" :show-overflow-tooltip="true">
                  <template #default="scope">{{ scope.row.cinemaName || (scope.row.dept ? scope.row.dept.deptName : '') }}</template>
               </el-table-column>
               <el-table-column :label="$t('user.phone')" align="center" key="phonenumber" prop="phonenumber" v-if="columns.length > 0 && columns[4].visible" width="120" />
               <el-table-column :label="$t('global.status')" align="center" key="status" v-if="columns.length > 0 && columns[5].visible">
                  <template #default="scope">
                     <el-switch
                        v-model="scope.row.status"
                        active-value="0"
                        inactive-value="1"
                        @change="handleStatusChange(scope.row)"
                     ></el-switch>
                  </template>
               </el-table-column>
               <el-table-column :label="$t('global.createTime')" align="center" prop="createTime" v-if="columns.length > 0 && columns[6].visible" width="160">
                  <template #default="scope">
                     <span>{{ parseTime(scope.row.createTime) }}</span>
                  </template>
               </el-table-column>
               <el-table-column :label="$t('global.operation')" align="center" width="150" class-name="small-padding fixed-width">
                  <template #default="scope">
                     <el-tooltip :content="$t('global.edit')" placement="top" v-if="scope.row.userId !== 1">
                        <el-button link type="primary" icon="Edit" @click="handleUpdate(scope.row)" v-hasPermi="['system:user:edit']"></el-button>
                     </el-tooltip>
                     <el-tooltip :content="$t('global.delete')" placement="top" v-if="scope.row.userId !== 1">
                        <el-button link type="primary" icon="Delete" @click="handleDelete(scope.row)" v-hasPermi="['system:user:remove']"></el-button>
                     </el-tooltip>
                     <el-tooltip :content="$t('global.resetPWD')" placement="top" v-if="scope.row.userId !== 1">
                         <el-button link type="primary" icon="Key" @click="handleResetPwd(scope.row)" v-hasPermi="['system:user:resetPwd']"></el-button>
                     </el-tooltip>
                     <el-tooltip :content="$t('user.assignRole')" placement="top" v-if="scope.row.userId !== 1">
                        <el-button link type="primary" icon="CircleCheck" @click="handleAuthRole(scope.row)" v-hasPermi="['system:user:edit']"></el-button>
                     </el-tooltip>
                  </template>
               </el-table-column>
            </el-table>
            <pagination
               v-show="total > 0"
               :total="total"
               v-model:page="queryParams.pageNum"
               v-model:limit="queryParams.pageSize"
               @pagination="getList"
            />
         </el-col>
      </el-row>

      <!-- 添加或修改用户配置对话框 -->
      <el-dialog :title="title" v-model="open" width="800px" append-to-body :close-on-click-modal="false">
         <el-form :model="form" :rules="rules" ref="userRef" label-width="120px" class="createForm">
            <el-row :gutter="10">
               <el-col :span="12">
                  <el-form-item :label="$t('user.abbr')" prop="nickName">
                     <el-input v-model="form.nickName" :placeholder="$t('user.abbr') + $t('global.plsInput')" maxlength="30" />
                  </el-form-item>
               </el-col>
               <el-col :span="12">
                  <el-form-item :label="$t('user.belongDept')" prop="deptId">
                     <LazyLoadSelect
                        v-model:modelValue="form.deptId"
                        :list="deptList"
                        :placeholder="$t('movie.companyIds') + $t('global.plsSelect')"
                        searchKey="deptName"
                        labelKey="deptName"
                        valueKey="deptId"
                        :fetchOptions="listDept"
                        @change="handleDeptChange"
                     />
                     <!-- <el-tree-select
                        v-model="form.deptId"
                        :data="deptOptions"
                        :props="{ value: 'id', label: 'label', children: 'children' }"
                        value-key="id"
                        :placeholder="$t('user.belongDept') + $t('global.plsSelect')"
                        check-strictly
                     /> -->
                  </el-form-item>
               </el-col>
            </el-row>
            <el-row :gutter="10">
               <el-col :span="12">
                  <el-form-item :label="$t('user.phone')" prop="phonenumber">
                     <el-input v-model="form.phonenumber" :placeholder="$t('user.phone') + $t('global.plsInput')" />
                  </el-form-item>
               </el-col>
               <el-col :span="12">
                  <el-form-item :label="$t('user.belongCinema')" prop="cinemaId">
                     <LazyLoadSelect
                        v-model:modelValue="form.cinemaId"
                        :list="cinemaList"
                        :placeholder="$t('user.belongCinema') + $t('global.plsSelect')"
                        searchKey="name"
                        labelKey="name"
                        valueKey="id"
                        :fetchOptions="listCinema"
                        @change="handleCinemaChange"
                     />
                  </el-form-item>
               </el-col>
            </el-row>
            <el-row :gutter="10">
               <el-col :span="12">
                  <el-form-item :label="$t('user.name')" prop="userName">
                     <el-input v-model="form.userName" :placeholder="$t('user.name') + $t('global.plsInput')" maxlength="30" />
                  </el-form-item>
               </el-col>
               <el-col :span="12">
                  <el-form-item :label="$t('user.email')" prop="email">
                     <el-input v-model="form.email" :placeholder="$t('user.email') + $t('global.plsInput')" maxlength="50" />
                  </el-form-item>
               </el-col>
            </el-row>
            <el-row :gutter="10" v-if="form.userId == undefined">
               <el-col :span="12">
                  <el-form-item :label="$t('user.pwd')" prop="password">
                     <el-input v-model="form.password" :placeholder="$t('user.pwd') + $t('global.plsInput')" type="password" maxlength="20" show-password />
                  </el-form-item>
               </el-col>
            </el-row>
            <el-row :gutter="10">
               <el-col :span="12">
                  <el-form-item :label="$t('user.gender')">
                     <keep-result-select
                        v-model="form.sex"
                        :list="sys_user_sex"
                     />
                  </el-form-item>
               </el-col>
               <el-col :span="12">
                  <el-form-item :label="$t('global.status')">
                     <el-radio-group v-model="form.status">
                        <el-radio
                           v-for="dict in sys_normal_disable"
                           :key="dict.value"
                           :label="dict.value"
                        >{{ dict.label }}</el-radio>
                     </el-radio-group>
                  </el-form-item>
               </el-col>
            </el-row>
            <el-row :gutter="10">
               <el-col :span="12">
                  <el-form-item :label="$t('user.position')">
                     <keep-result-select
                        v-model="form.postIds"
                        :list="postOptions"
                        labelKey="postName"
                        valueKey="postId"
                        :optionDisabled="true"
                        :multiple="true"
                     />
                  </el-form-item>
               </el-col>
               <el-col :span="12">
                  <el-form-item :label="$t('user.role')">
                     <keep-result-select
                        v-model="form.roleIds"
                        :list="roleOptions"
                        labelKey="roleName"
                        valueKey="roleId"
                        :optionDisabled="true"
                        :multiple="true"
                     />
                  </el-form-item>
               </el-col>
            </el-row>
            <el-row>
               <el-col :span="24">
                  <el-form-item :label="$t('user.remark')" prop="remark">
                     <el-input v-model="form.remark" type="textarea"></el-input>
                  </el-form-item>
               </el-col>
            </el-row>
         </el-form>
         <template #footer>
            <div class="dialog-footer">
               <el-button type="primary" @click="submitForm">{{ $t('global.confirm') }}</el-button>
               <el-button @click="cancel">{{ $t('global.cancel') }}</el-button>
            </div>
         </template>
      </el-dialog>

      <!-- 用户导入对话框 -->
      <el-dialog :title="upload.title" v-model="upload.open" width="400px" append-to-body :close-on-click-modal="false">
         <el-upload
            ref="uploadRef"
            :limit="1"
            accept=".xlsx, .xls"
            :headers="upload.headers"
            :action="upload.url + '?updateSupport=' + upload.updateSupport"
            :disabled="upload.isUploading"
            :on-progress="handleFileUploadProgress"
            :on-success="handleFileSuccess"
            :auto-upload="false"
            drag
         >
            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
            <div class="el-upload__text">{{`${$t('global.dragFile')}，${$t('global.or')}`}}<em>{{ $t('global.clickUpload') }}</em></div>
            <template #tip>
               <div class="el-upload__tip text-center">
                  <div class="el-upload__tip">
                     <el-checkbox v-model="upload.updateSupport" />{{ $t('global.updateExistData') }}
                  </div>
                  <span>{{ $t('global.onlyImportFile') }}</span>
                  <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;" @click="importTemplate">{{ $t('global.downloadTemplate') }}</el-link>
               </div>
            </template>
         </el-upload>
         <template #footer>
            <div class="dialog-footer">
               <el-button type="primary" @click="submitFileForm">{{ $t('global.confirm') }}</el-button>
               <el-button @click="upload.open = false">{{ $t('global.cancel') }}</el-button>
            </div>
         </template>
      </el-dialog>
   </div>
</template>

<script setup name="User">
import { useI18n } from 'vue-i18n';
import { ElMessageBox } from 'element-plus';
import { getToken } from '@/utils/auth';
import {
  changeUserStatus, listUser, resetUserPwd, delUser, getUser, updateUser, addUser, deptTreeSelect,
} from '@/api/system/user';
import { listDept } from '@/api/system/dept';
import { listCinema } from '@/api/system/cinema';
import { checkTextOverflow, truncateText, japaneseCharacters } from '@/utils/common';

const { t } = useI18n();
const router = useRouter();
const { proxy } = getCurrentInstance();
const { sys_normal_disable, sys_user_sex } = proxy.useDict('sys_normal_disable', 'sys_user_sex');

const userList = ref([]);
const open = ref(false);
const loading = ref(true);
const showSearch = ref(true);
const ids = ref([]);
const single = ref(true);
const multiple = ref(true);
const total = ref(0);
const title = ref('');
const dateRange = ref([]);
const deptName = ref('');
const deptOptions = ref(undefined);
const initPassword = ref(undefined);
const postOptions = ref([]);
const roleOptions = ref([]);
const deptList = ref([]);
const cinemaList = ref([]);
const isSyncingSelection = ref(false);
const multipleTable = ref(null);

const selectRef = ref(null);
const currentPage = ref(1);
const totalItems = ref(0);
const loadMoreLoading = ref(false);

/** * 用户导入参数 */
const upload = reactive({
  // 是否显示弹出层（用户导入）
  open: false,
  // 弹出层标题（用户导入）
  title: '',
  // 是否禁用上传
  isUploading: false,
  // 是否更新已经存在的用户数据
  updateSupport: 0,
  // 设置上传的请求头部
  headers: { Authorization: `Bearer ${getToken()}` },
  // 上传的地址
  url: `${import.meta.env.VITE_APP_BASE_API}/system/user/importData`,
});
// 列显隐信息
const columns = ref([
  { key: 0, label: t('user.userId'), visible: true },
  { key: 1, label: t('user.name'), visible: true },
  { key: 2, label: t('user.abbr'), visible: true },
  { key: 3, label: t('user.dept'), visible: true },
  { key: 4, label: t('user.phone'), visible: true },
  { key: 5, label: t('global.status'), visible: true },
  { key: 6, label: t('global.createTime'), visible: true },
]);
const data = reactive({
  form: {},
  queryParams: {
    pageNum: 1,
    pageSize: 50,
    userName: undefined,
    phonenumber: undefined,
    status: undefined,
    deptId: undefined,
  },
  rules: {
    userName: [
      { validator: proxy.$validateEmpty(t('user.name') + t('global.plsInput'), true), required: true, trigger: 'blur' },
      {
        min: 2, max: 20, message: t('user.name') + t('global.limitLength', { min: '2', max: '20' }), trigger: 'blur',
      },
    ],
    nickName: [
      { validator: proxy.$validateEmpty(t('user.abbr') + t('global.plsInput'), true), required: true, trigger: 'blur' },
    ],
    phonenumber: [
      { validator: proxy.$validateEmpty(), trigger: 'blur' },
    ],
    password: [
      { validator: proxy.$validateEmpty(t('user.pwd') + t('global.plsInput'), true), required: true, trigger: 'blur' },
      {
        min: 5, max: 20, message: t('user.pwd') + t('global.limitLength', { min: '5', max: '20' }), trigger: 'blur',
      },
    ],
    email: [{ type: 'email', message: t('global.invalidEmail') + t('global.plsInput'), trigger: ['blur', 'change'] }],
    //  phonenumber: [{ pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: t('global.invalidPhone') + t('global.plsInput'), trigger: 'blur' }],
    remark: [
      { validator: proxy.$validateEmpty(), trigger: 'blur' },
    ],
  },
});

const { queryParams, form, rules } = toRefs(data);

/** 通过条件过滤节点  */
const filterNode = (value, data) => {
  if (!value) return true;
  return data.label.indexOf(value) !== -1;
};
/** 根据名称筛选部门树 */
watch(deptName, (val) => {
  proxy.$refs.deptTreeRef.filter(val);
});
/** 查询部门下拉树结构 */
function getDeptTree() {
  deptTreeSelect().then((response) => {
    deptOptions.value = response.data;
  });
}
function syncSelection() {
  proxy.$refs.multipleTable.clearSelection();
  userList.value.forEach((row) => {
    if (ids.value.includes(row.userId)) {
      proxy.$refs.multipleTable.toggleRowSelection(row, true);
    }
  });
}

/** 查询用户列表 */
function getList() {
  isSyncingSelection.value = true;
  loading.value = true;
  listUser(proxy.addDateRange(queryParams.value, dateRange.value)).then((res) => {
    loading.value = false;
    userList.value = res.rows;
    total.value = res.total;
    proxy.$nextTick(() => {
      syncSelection();
      isSyncingSelection.value = false; // 重置标志
    });
  });
}
// 获取会社列表
function getDeptList() {
  listDept({
    pageNum: 1,
    pageSize: 20,
  }).then((response) => {
    deptList.value = response.rows;
    loading.value = false;
  });
}
// 获取劇場列表
function getCinemaList() {
  listCinema({
    pageNum: 1,
    pageSize: 20,
  }).then((response) => {
    cinemaList.value = response.rows;
  });
}
/** 部门与劇場绑定互斥：选择一方时清空另一方 */
function handleDeptChange(val) {
  if (val) form.value.cinemaId = undefined;
}
function handleCinemaChange(val) {
  if (val) form.value.deptId = undefined;
}
/** 节点单击事件 */
function handleNodeClick(data) {
  queryParams.value.deptId = data.id;
  handleQuery();
}
/** 搜索按钮操作 */
function handleQuery() {
  queryParams.value.pageNum = 1;
  getList();
}
/** 重置按钮操作 */
function resetQuery() {
  dateRange.value = [];
  proxy.resetForm('queryRef');
  queryParams.value.deptId = undefined;
  // proxy.$refs.deptTreeRef.setCurrentKey(null);
  handleQuery();
}
/** 删除按钮操作 */
function handleDelete(row) {
  const userIds = row.userId || ids.value;
  proxy.$modal.confirm(`${t('global.confirmDelete')}${userIds}？`).then(function () {
    return delUser(userIds);
  }).then(() => {
    getList();
    proxy.$modal.msgSuccess(proxy.$t('global.deleteSuccess'));
    ids.value = [];
    multiple.value = true;
  }).catch(() => {});
}
/** 导出按钮操作 */
function handleExport() {
  proxy.download('system/user/export', {
    ...queryParams.value,
  }, `user_${new Date().getTime()}.xlsx`);
}
/** 用户状态修改  */
function handleStatusChange(row) {
  const text = row.status === '0' ? t('global.on') : t('global.off');
  proxy.$modal.confirm(t('global.confirmActiveUser', { text, userName: row.userName })).then(function () {
    return changeUserStatus(row.userId, row.status);
  }).then(() => {
    proxy.$modal.msgSuccess(text + proxy.$t('global.success'));
  }).catch(function () {
    row.status = row.status === '0' ? '1' : '0';
  });
}
/** 更多操作 */
function handleCommand(command, row) {
  switch (command) {
    case 'handleResetPwd':
      handleResetPwd(row);
      break;
    case 'handleAuthRole':
      handleAuthRole(row);
      break;
    default:
      break;
  }
}
/** 跳转角色分配 */
function handleAuthRole(row) {
  const userId = row.userId;
  router.push(`/system/user-auth/role/${userId}`);
}
/** 重置密码按钮操作 */
function handleResetPwd(row) {
  ElMessageBox.prompt(`${t('global.plsInputNewPWD', { userName: row.userName })}`, t('global.tips'), {
    confirmButtonText: t('global.confirm'),
    cancelButtonText: t('global.cancel'),
    closeOnClickModal: false,
    // inputPattern: /^.{5,20}$/,
    // inputErrorMessage: t('user.pwd') + t('global.limitLength', { min: '5', max: '20' }),
    inputValidator: (value) => {
      const reg = /\r\n|\r|\n|\t/;
      const minLengthPattern = /^.{5,20}$/;
      const regexPattern = japaneseCharacters.join('|');
      const regex = new RegExp(regexPattern, 'g');
      const matches = value.match(regex);

      if (!minLengthPattern.test(value)) {
        return t('user.pwd') + t('global.limitLength', { min: '5', max: '20' });
      }
      if (reg.test(value)) {
        return '入力内容に改行が存在しています。';
      }
      if (matches) {
        return `入力内容に機種依存文字が存在しています。「${matches}」`;
      }
      return true; // 验证通过
    },
  }).then(({ value }) => {
    resetUserPwd(row.userId, value).then((response) => {
      proxy.$modal.msgSuccess(`${proxy.$t('global.editPWSuccess')}：${value}`);
    });
  }).catch(() => {});
}
/** 选择条数  */
function handleSelectionChange(selection) {
  if (isSyncingSelection.value) return; // 在同步过程中，不处理选中状态变更
  const selectedIdsOnCurrentPage = userList.value.map((item) => item.userId);
  ids.value = ids.value
    .filter((id) => !selectedIdsOnCurrentPage.includes(id)) // 移除当前页面不再选中的ID
    .concat(selection.map((item) => item.userId)); // 添加当前页面新选中的ID
  multiple.value = !ids.value.length;
}
/** 导入按钮操作 */
function handleImport() {
  upload.title = t('global.userImport');
  upload.open = true;
}
/** 下载模板操作 */
function importTemplate() {
  proxy.download('system/user/importTemplate', {
  }, `user_template_${new Date().getTime()}.xlsx`);
}
/** 文件上传中处理 */
const handleFileUploadProgress = (event, file, fileList) => {
  upload.isUploading = true;
};
/** 文件上传成功处理 */
const handleFileSuccess = (response, file, fileList) => {
  upload.open = false;
  upload.isUploading = false;
  proxy.$refs.uploadRef.handleRemove(file);
  ElMessageBox.alert(`<div style='overflow: auto;overflow-x: hidden;max-height: 70vh;padding: 10px 20px 0;'>${response.msg}</div>`, t('global.importResult'), { dangerouslyUseHTMLString: true, closeOnClickModal: false });
  getList();
};
/** 提交上传文件 */
function submitFileForm() {
  proxy.$refs.uploadRef.submit();
}
/** 重置操作表单 */
function reset() {
  form.value = {
    userId: undefined,
    deptId: undefined,
    cinemaId: undefined,
    userName: undefined,
    nickName: undefined,
    password: undefined,
    phonenumber: undefined,
    email: undefined,
    sex: undefined,
    status: '0',
    remark: undefined,
    postIds: [],
    roleIds: [],
  };
  proxy.resetForm('userRef');
}
/** 取消按钮 */
function cancel() {
  open.value = false;
  reset();
}
/** 新增按钮操作 */
function handleAdd() {
  reset();
  getUser().then((response) => {
    postOptions.value = response.posts;
    roleOptions.value = response.roles;
    open.value = true;
    title.value = t('user.title') + t('global.add');
    form.value.password = initPassword.value;
  });
}
/** 修改按钮操作 */
function handleUpdate(row) {
  reset();
  const userId = row.userId || ids.value;
  getUser(userId).then((response) => {
    form.value = response.data;
    postOptions.value = response.posts;
    roleOptions.value = response.roles;
    form.value.postIds = response.postIds;
    form.value.roleIds = response.roleIds;
    open.value = true;
    title.value = t('user.title') + t('global.edit');
    form.password = '';
  });
}
/** 提交按钮 */
function submitForm() {
  proxy.$refs.userRef.validate((valid) => {
    if (valid) {
      if (form.value.userId != undefined) {
        updateUser(form.value).then((response) => {
          proxy.$modal.msgSuccess(proxy.$t('global.editSuccess'));
          open.value = false;
          getList();
        });
      } else {
        addUser(form.value).then((response) => {
          proxy.$modal.msgSuccess(proxy.$t('global.addSuccess'));
          open.value = false;
          getList();
        });
      }
    }
  });
}

function selectable(row, index) {
  return !row.admin;
}

watch(() => open.value, (v) => {
  if (v && form.value.deptId) {
    listDept({
      ids: [form.value.deptId],
      pageNum: 1,
      pageSize: 99999,
    }).then((res) => {
      deptList.value = proxy.$_.uniqBy([...res.rows, ...deptList.value], 'deptId');
    });
  }
  // 劇場列表接口不支持 ids 过滤，直接用 getUser 回显的 cinemaId/cinemaName 补充选项
  if (v && form.value.cinemaId && form.value.cinemaName) {
    cinemaList.value = proxy.$_.uniqBy([{ id: form.value.cinemaId, name: form.value.cinemaName }, ...cinemaList.value], 'id');
  }
});
// 关键字搜索
// const debounceSearch = proxy.$_.debounce(async (query) => {
//   await listDept({
//     ...query ? { deptName: query } : {},
//     pageNum: 0,
//     pageSize: 20,
//   }).then((response) => {
//     deptList.value = response.rows;
//   });
// }, 500);
// // list懒加载
// function loadMoreFn() {
//   if (loadMoreLoading.value || (totalItems.value && totalItems.value <= deptList.value.length)) return;
//   loadMoreLoading.value = true;
//   listDept({
//     pageNum: currentPage.value,
//     pageSize: 20,
//   }).then((response) => {
//     deptList.value = [...deptList.value, ...response.rows];
//     totalItems.value = response.total;
//     currentPage.value += 1;
//     loadMoreLoading.value = false;
//   });
// }

// getDeptTree();
getList();
getDeptList();
getCinemaList();
</script>
<style lang="scss" scoped>
   .createForm .el-row {
      margin-bottom: 10px;
   }
   .companyTree .el-tree-node__label {
      overflow: hidden;
   }
</style>
